import { render, staticRenderFns } from "./TourismNews.vue?vue&type=template&id=49cf568e&"
import script from "./TourismNews.vue?vue&type=script&lang=js&"
export * from "./TourismNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports